import { SynchTripImportDTO } from 'business/models/Models';
import SynchTripService from 'business/services/SynchrotronTripService';
import React, { useContext, useEffect, useState } from 'react';
import ImportSynchTripWizardContext from './importSynchTripWizardContext';
import SynchTripVerificationTable from './synchTripVerificationTable';

interface recordsCountType {
  validRecords: number;
  invalidRecords: number;
}
const recordsCountInit = {
  validRecords: 0,
  invalidRecords: 0,
};

const DataVerficationPage = () => {
  const [synchTripResult, setSynchTripResult] = useState<SynchTripImportDTO[]>();
  const synchTripContext = useContext(ImportSynchTripWizardContext);
  const [recordsCount, setRecordsCount] = useState<recordsCountType>(recordsCountInit);
  const synchTripImportDTOList: SynchTripImportDTO[] =
    synchTripContext.synchTripImportDTOList;
  const synchTripService: SynchTripService = new SynchTripService();

  useEffect(() => {
    synchTripContext.setNextButtonDisallowed(true);

    validateData();
  }, []);

  const updateFooter = (synchTripResultData: SynchTripImportDTO[]) => {
    const validCount = synchTripResultData.filter((t) => t.errorMessage == '').length;
    const invalidCount = synchTripResultData.filter((t) => t.errorMessage != '').length;

    setRecordsCount({ validRecords: validCount, invalidRecords: invalidCount });

    return validCount;
  };

  const validateData = async () => {
    const synchTripResultData = await synchTripService.verifySynchTripImportData(
      synchTripImportDTOList,
    );
    setSynchTripResult(synchTripResultData);
    synchTripContext.setSynchTripImportDTOList(synchTripResultData);

    const validCount = updateFooter(synchTripResultData);

    if (validCount > 0) {
      synchTripContext.setNextButtonDisallowed(false);
    }
  };

  return (
    <>
      <div
        id="dataverificationpage-synctripresult-wrapper"
        className="flex flex-column w-320 h-full overflow-auto"
      >
        {synchTripResult && (
          <SynchTripVerificationTable
            tableData={synchTripResult}
          ></SynchTripVerificationTable>
        )}
      </div>
      <div id="dataverificationpage-records-wrapper" className="flex flex-row">
        <div id="dataverificationpage-records-valid" className="flex flex-row">
          <div id="dataverificationpage-records-valid-text" className="font-semibold">
            Valid:&nbsp;
          </div>{' '}
          {recordsCount.validRecords}
        </div>
        <div id="dataverificationpage-records-empty" className="w-8"></div>
        <div id="dataverificationpage-records-invalid" className="flex flex-row">
          <div id="dataverificationpage-records-invalid-text" className="font-semibold">
            Invalid:&nbsp;
          </div>{' '}
          {recordsCount.invalidRecords}
        </div>
      </div>
    </>
  );
};

export default DataVerficationPage;
